import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/default.vue").then(m => m.default || m)),
  "no-container": defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/noContainer.vue").then(m => m.default || m))
}